<app-traitement-data titre="Fréquence respiratoire (médiane - 95%)"
    [sousTitre]="patient!.tableauDeBord?.frequenceRespiratoireMediane?.date | aLaDateDu">
    {{ (patient!.tableauDeBord?.frequenceRespiratoireMediane?.value) ?? 'Ø' }} -
    {{ (patient!.tableauDeBord?.frequenceRespiratoire95?.value) ?? 'Ø' }}
</app-traitement-data>